var _ = require('underscore');
var Marionette = require('marionette');
var Dialog = require('Dialog');
var Labels = EY.Consultation.Labels;
var Validation = require('validation');

var Comments = Marionette.View.extend({
    events: {
        'keyup @ui.deleteReason': 'update'
    },
    initialize: function () {
        Validation.bind(this);
    },
    template: '#dialogDeleteConfirm',
    ui: {
        deleteReason: '#deleteReason'
    },
    update: function () {
        this.model.set('deleteReason', this.ui.deleteReason.val().trim());
    }
});

module.exports.show = function (options) {
    var model = options.model;
    model.defaultValidation = model.validation;
    model.validation = model.deleteReasonValidation;
    return Dialog.show({
        cancelLabel: Labels.No,
        headerLabel: Labels.DialogTitleWarning,
        saveLabel: Labels.Yes,
        validate: model,
        view: new Comments({
            model: model
        })
    }).always(function () {
        model.validation = model.defaultValidation;
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Dialog/DialogDeleteConfirm.js